let newInterval = null;
const segundo = 1000 // ? 1000 = 1 segundo 
const minutoSegundo = 60 // ? 1000 * 60 = 60 segundos = 1 minuto
// const minutoSegundo = 5 // ? 1000 * 5 = 5 segundos = 1 minuto
const minutos = 2

import toastr from 'toastr'

// ? 2 minutos 0.03 -> 3 minutos 0.05
// ? 4 minutos 0.06 -> 5 minutos 0.083
// ? 6 minutos 0.1  -> 7 minutos 0.11

// ? 10 minutos 0.16
// ? 15 minutos 0.25
// ? 20 minutos 0.33
// ? 25 minutos 0.41
// ? 30 minutos 0.5
// ? 35 minutos 0.58
// ? 40 minutos 0.66
// ? 45 minutos 0.75
// ? 50 minutos 0.83
// ? 55 minutos 0.91

// const HoraLimite = [
//     {id:1, name:"alert01", timeStampInit:0.03*60*60000, timeStampEnd:0.05*60*60000, active:false, message:"falta 50 minutos para expirar la sesion"}, // ? 10 = horas <-> 60 = minutos
//     {id:2, name:"alert02", timeStampInit:0.06*60*60000, timeStampEnd:0.083*60*60000,  active:false, message:"falta 30 minutos para expirar la sesion"}, // ? 10 = horas <-> 60 = minutos
//     {id:3, name:"alert03", timeStampInit:0.01*60*60000, timeStampEnd:0.11*60*60000,  active:false, message:"falta 10 minutos para expirar la sesion"} // ? 10 = horas <-> 60 = minutos
// ]


export const startAlert = () => {
    let HoraLimite = [
        {id:1, name:"alert01", timeStampInit:5.16*60*60000, timeStampEnd:5.25*60*60000, active:false, message:"Falta 50 minutos para expirar la sesion"}, // ? 10 = horas <-> 60 = minutos
        {id:2, name:"alert02", timeStampInit:5.5*60*60000, timeStampEnd:5.59*60*60000,  active:false, message:"Falta 30 minutos para expirar la sesion"}, // ? 10 = horas <-> 60 = minutos
        {id:3, name:"alert03", timeStampInit:5.77*60*60000, timeStampEnd:5.87*60*60000,  active:false, message:"Falta 10 minutos para expirar la sesion"} // ? 10 = horas <-> 60 = minutos
    ]

    newInterval = setInterval(() => {
        const access_token = localStorage.getItem('access_token');
        const access_date = localStorage.getItem('access_date');
        if(access_token && access_date){
            // ! valida que tenga un token y este asociado
            HoraLimite = HoraLimite.map((item)=>{
                const newDateInit = parseFloat(access_date) + parseFloat(item.timeStampInit)
                const newDateEnd = parseFloat(access_date) + parseFloat(item.timeStampEnd)
                const dateNow = Date.now()
                if(!item.active && dateNow > newDateInit){
                    if(dateNow > newDateInit && dateNow < newDateEnd){
                        console.log(newDateInit, newDateEnd, dateNow)
                        console.log(item.message)
                        item.active = true
                        toastr.options = {
                            "closeButton": false,
                            "debug": false,
                            "newestOnTop": false,
                            "progressBar": false,
                            "positionClass": "toast-top-right",
                            "preventDuplicates": false,
                            "onclick": null,
                            "showDuration": "500",
                            "hideDuration": "1000",
                            "timeOut": "5000",
                            "extendedTimeOut": "1000",
                            "showEasing": "swing",
                            "hideEasing": "linear",
                            "showMethod": "fadeIn",
                            "hideMethod": "fadeOut"
                          }
                
                        toastr.warning(item.message);
                    }
                }
                return item
            })
        }

    }, segundo*minutoSegundo*minutos); 
}

// export const cancelAlert = () => {
//     if(newInterval)clearTimeout(newInterval);
// }
